import React from 'react';
import Modal from "react-modal";
import "./FailModal.css";
import Error from "../../../assets/lottie/Error.json";
import Lottie from "lottie-react";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

const style = {
    width: "24%",
    height: "109px",
    margin: "0 auto",
    display: "flex",
    justifycontent: "center",
    alignItems: "center"
};

const FailModal = (props) => {
    const { openFailModal, setOpenFailModal, failMessage, recallFunctionOnOk, recallFunctiononClose, donwloadAudit, setDownloadAudit } = props;

    const closeModal = () => {
        setOpenFailModal(false);
        recallFunctiononClose();
    };

    const handleOkButtonClick = () => {
        if (donwloadAudit) {
            setDownloadAudit(true);
        }
        recallFunctionOnOk();
    };

    return (
        <Modal
            isOpen={openFailModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
            shouldCloseOnOverlayClick={false}
        >
            <div className="inner-fail-modal">
                <div className="close-btn" onClick={closeModal}><span>X</span></div>
                <div className="fail-image">
                    <Lottie animationData={Error} style={style} />
                </div>
                <div className="modal-message">
                    {failMessage}
                </div>
                <div className="ok-btn">
                    <button data-testid="handleOkButtonClickModule" onClick={handleOkButtonClick}>{donwloadAudit ? "Download" : "OK"}</button>
                </div>
            </div>
        </Modal>
    );
};

export default FailModal;
